<template>
<div class="log">
<el-breadcrumb separator-class="el-icon-arrow-right" class="map_path">
  <el-breadcrumb-item @click.native="pathSel(e,i)" v-for="(e,i) in currentPath" :key="i">{{e.name}}</el-breadcrumb-item>
</el-breadcrumb>
  <el-table
    :data="tableData"
    style="width: 100%"
    :height="tableHeight"
    :highlight-current-row="true"
    @row-dblclick="rowDbclick"
    :default-sort = "{prop: 'date', order: 'descending'}"
    >
    <el-table-column
      prop="name"
      label="名称"
      sortable
     >
         <template slot-scope="scope">
        <i class="el-icon-folder" v-if="scope.row.isFolder"> {{scope.row.name}}</i>
         <i class="el-icon-document" v-else> {{scope.row.name}}</i>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建日期"
      sortable
      >
    </el-table-column>
    <el-table-column
      prop="lastTime"
      label="修改日期"
      sortable
     >
    </el-table-column>
       <el-table-column
      prop="size"
      label="文件大小"
     >
    </el-table-column>
    <el-table-column
      prop="docType"
      label="类型"
     >
    </el-table-column>
             <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="100">
                <template slot-scope="scope" v-if="!scope.row.isFolder">
                  <el-button @click="download(scope.row)"
                             type="success"
                             size="mini">下载</el-button>
                </template>
              </el-table-column>
  </el-table>
</div>
</template>
<script>
import { device as api } from '../../api/device'
export default {
  data () {
    return {
      tableData: [],
      tableHeight: 0,
      currentPath: [{name: 'root', path: 'root'}]
    }
  },
  methods: {
    rowDbclick (row, column, event) {
      if (row.isFolder) {
        api.getLogFolderAndFiles({folderName: row.name, path: row.fullPath}).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.currentPath.push({name: row.name, path: row.fullPath})
              this.tableData = data.Data
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      } else {
        this.download(row)
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 140
      obj.tableHeight = clientHeight
    },
    pathSel (row, i) {
      var queryParam = i === 0 ? {folderName: 'root'} : {folderName: row.name, path: row.path}
      api.getLogFolderAndFiles(queryParam).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.currentPath.splice(i + 1, this.currentPath.length - i + 1)
            this.tableData = data.Data
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    download (row) {
      var filename = row.lastTime.replaceAll(':', '.') + '.' + row.name
      api.downloadFile({filePath: row.fullPath}).then(res => {
        console.log(res)
        if (res.data) {
          var blob = new Blob([res.data])

          if (window.navigator.msSaveBlob) {
            // IE 对a标签下载不支持。微软有自己的下载方法msSaveBlob()。
            try {
              window.navigator.msSaveBlob(blob, filename)
            } catch (e) {
              console.log(e)
            }
          } else {
            var url = URL.createObjectURL(blob)
            var a = document.createElement('a')
            document.body.appendChild(a)
            a.style.display = 'none'
            a.target = '_blank'
            a.href = url
            a.download = filename
            a.target = '_blank'
            a.click()
            document.body.removeChild(a)
          }
        }
      })
    }
  },
  created () {
    api.getLogFolderAndFiles({folderName: 'root'}).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.tableData = data.Data
        } else {
          this.$message.error('提示：' + data.Msg)
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
.log  .el-breadcrumb__item:hover .el-breadcrumb__inner{
  color: #409eff;
   cursor: pointer;
}
</style>
<style scoped>
.map_path{
 margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/view/device/log.vue